import React from "react"
import Layout from "../components/layout"

import { useTranslation } from "gatsby-plugin-react-i18next"
import { graphql } from "gatsby"
import Seo from "../components/seo"

const ContactPage = () => {
  const { t, i18n } = useTranslation()
  return (
    <Layout page="contact">
      <Seo title="Contact" />
      <div className="page_container contactPage">
        <div className="contact">
          <form
            name="contact"
            className="contact__form"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            action={i18n.language === "en" ? "/en/success" : "/success"}
          >
            {/* <input type="hidden" name="form-name" value="Contact Form" /> */}
            <p className="hidden">
              <label>
                Don’t fill this out if you're human: <input name="bot-field" />
              </label>
            </p>
            <input type="hidden" name="form-name" value="contact" />
            <textarea
              className="contact__form__text"
              name="message"
              placeholder={t("Contact.form.your message")}
            ></textarea>

            <input
              className="contact__form__name"
              type="text"
              name="name"
              placeholder={t("Contact.form.name")}
            />
            <input
              type="email"
              name="email"
              placeholder={t("Contact.form.email")}
            />
            <button type="submit">{t("Contact.form.send")}</button>
          </form>
        </div>
      </div>
    </Layout>
  )
}

export default ContactPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
